import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Formatea una fecha ISO como hora en formato 24h: "13:00"
 *  Fuerza timezone Argentina para consistencia con el backend */
export function formatHora24(fechaHora: string | Date): string {
  const d = typeof fechaHora === "string" ? new Date(fechaHora) : fechaHora
  return d.toLocaleTimeString("es-AR", {
    hour: "2-digit", minute: "2-digit",
    hour12: false,
    timeZone: "America/Argentina/Buenos_Aires",
  })
}

/** Formatea fecha como "08/04/26" con timezone Argentina */
export function formatFecha(fechaHora: string | Date): string {
  const d = typeof fechaHora === "string" ? new Date(fechaHora) : fechaHora
  return d.toLocaleDateString("es-AR", {
    day: "2-digit", month: "2-digit", year: "2-digit",
    timeZone: "America/Argentina/Buenos_Aires",
  })
}

/** Formatea fecha+hora completa en ART: "miércoles, 23 de septiembre de 2026 a las 15:00".
 *  2026-09-23 (P0-F1): fuerza America/Argentina/Buenos_Aires para que el paciente vea
 *  la hora del turno en la zona de la clínica, NO en la tz local de su navegador
 *  (antes usaba date-fns format() que renderiza en tz local → un usuario en EE.UU.
 *  veía el turno 4-7 hs desfasado). */
export function formatFechaHoraART(fechaHora: string | Date): string {
  const d = typeof fechaHora === "string" ? new Date(fechaHora) : fechaHora
  const fecha = d.toLocaleDateString("es-AR", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
    timeZone: "America/Argentina/Buenos_Aires",
  })
  const hora = d.toLocaleTimeString("es-AR", {
    hour: "2-digit", minute: "2-digit", hour12: false,
    timeZone: "America/Argentina/Buenos_Aires",
  })
  return `${fecha} a las ${hora}`
}

/** 
 * Formatea una fecha de nacimiento (YYYY-MM-DD) a (DD/MM/YYYY)
 * Evita el desfase de zona horaria al no usar new Date() sobre strings ISO puros.
 */
export function formatFechaNacimiento(dateString: string | null | undefined): string {
  if (!dateString) return "—"
  
  // Si viene en formato YYYY-MM-DD (ISO date only)
  if (/^\d{4}-\d{2}-\d{2}/.test(dateString)) {
    const [year, month, day] = dateString.split("-")
    return `${day.slice(0, 2)}/${month}/${year}`
  }

  // Fallback por si viniera un objeto Date o string con hora
  const d = new Date(dateString)
  if (isNaN(d.getTime())) return "—"
  return d.toLocaleDateString("es-AR")
}
